import React, { useEffect, useState } from "react";
import { IonPage, IonContent, IonAccordionGroup, IonAccordion, IonItem, IonLabel, IonList } from '@ionic/react';
import './Survey.css';
import Footer from "../components/Footer";
import Header from "../components/Header";
import { InAppBrowser, InAppBrowserOptions } from "@awesome-cordova-plugins/in-app-browser";
import env from '../env.json'
import ReactGA from "react-ga4";
import axios from "axios";

// const PHP_PROXY_URL_HOME_SECTIONS = 'https://portal.mastinseguridad.com/apisapp/ga_proxy.php';

// const getOrCreateGaClientIdForHome = (): string => {
//   let clientId = localStorage.getItem('ga_client_id');
//   if (!clientId) {
//     clientId = typeof self !== 'undefined' && self.crypto?.randomUUID ? 
//                self.crypto.randomUUID() : 
//                `uuid-${Date.now()}-${Math.random().toString(36).substring(2)}`;
//     localStorage.setItem('ga_client_id', clientId);
//   }
//   return clientId;
// };

// const user = localStorage.getItem('profile') as string;
// const profile = user ? JSON.parse(user) : null;
// const userIdForGa = profile?.id?.toString() ?? undefined; 

// const clientIdForGa = getOrCreateGaClientIdForHome();

// const payloadToProxyHome = {
//   client_id: clientIdForGa,
//   user_id: userIdForGa, 
//   event_name: 'page_view', 
//   event_params: {         
//       page_location: '/pages/Survey',
//       page_title: 'Survey'
//   }
// };

// console.log('Enviando page_view inicial a proxy GA:', payloadToProxyHome);
// fetch(PHP_PROXY_URL_HOME_SECTIONS, {
//   method: 'POST',
//   headers: { 'Content-Type': 'application/json' },
//   body: JSON.stringify(payloadToProxyHome)
// })
// .then(response => {
//   if (!response.ok) {
//     response.json().then(err => console.error('Error desde proxy GA (page_view):', err)).catch(() => console.error('Error desde proxy GA (Home page_view), respuesta no JSON'));
//   } else {
//     response.json().then(data => console.log('Éxito vía proxy GA (page_view):', data)).catch(() => console.log('Éxito vía proxy GA (Home page_view), respuesta no JSON'));
//   }
// })
// .catch(error => {
//   console.error('Error de red contactando proxy GA (page_view):', error);
// }); 

// ReactGA.send({ hitType: "pageview", page: "/pages/Survey", title: "Survey" });

const Survey: React.FC = () => {
    const [surveys, setSurveys] = useState([{id: '', name: '', description: '', url: '', status: ''}]);

    const url = env.REACT_APP_URL;

    const token = localStorage.getItem('token');
    const header = {
        'Authorization': 'Bearer ' + token
    }

    const getSurveys = async () => {
        const instance = axios.create({
            baseURL: url,
            headers: header
        })

        await instance.get('/api/surveys')
        .then(res => {
            setSurveys(res.data);
        })
    }
    
    useEffect( () => {
        getSurveys();
    }, [])

    const openWebview = async (fullUrl: string) => {
        let options: InAppBrowserOptions = {location: 'no', hideurlbar: 'no'}
        let target = "_blank";
        InAppBrowser.create(fullUrl, target, options );
    };

    const realizarEncuesta = (url: string) => {
        window.location.href = '/encuesta?url=' + url
        // console.log(url)
    }

    console.log(surveys)

    if(surveys[0].id == '') {
        return(
            <IonPage>
                <Header pageName="Encuestas" />
                <IonContent>
                    <div className="container justify-content-center no-encuestas">
                        <h3>No hay encuestas disponibles</h3>
                    </div>
                </IonContent>
                <Footer />
            </IonPage>
        );
    }

    else {

        return(
            <IonPage>
                <Header pageName="Encuestas" />
                <IonContent>
                <IonAccordionGroup>
                        {
                            surveys.map( survey => {
                                return (
                                    <IonAccordion key={survey.id}>
                                        <IonItem slot="header">
                                            <p>{survey.name}</p>
                                        </IonItem>
                                        <IonList slot="content">
                                            <IonItem>
                                                <p>{survey.description}</p>
                                            </IonItem>
                                            <IonItem>
                                                { survey.status === 'OPEN' ? <a onClick={ () => openWebview(survey.url) } >Realizar encuesta.</a> : <a className="cerrada">Encuesta Cerrada</a>}
                                            </IonItem>
                                        </IonList>
                                    </IonAccordion>
                                );
                            }) 
                        }
                    </IonAccordionGroup>
                </IonContent>
                <Footer />
            </IonPage>
        );
    }
}

export default Survey;
